export const UserAPI = {
  login: {
    // api: 'authentication/signin',
    api: 'authentication/landing/signin',
    isPublicApi: true,
  },
  register: {
    api: 'signup',
    isPublicApi: true,
  },
};
